import { render, staticRenderFns } from "./DocumentationExample.vue?vue&type=template&id=56983f2e"
import script from "./DocumentationExample.vue?vue&type=script&lang=js"
export * from "./DocumentationExample.vue?vue&type=script&lang=js"
import style0 from "./DocumentationExample.vue?vue&type=style&index=0&id=56983f2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports